import { render, staticRenderFns } from "./LocationType.vue?vue&type=template&id=d5dc5d38&scoped=true&"
import script from "./LocationType.vue?vue&type=script&lang=js&"
export * from "./LocationType.vue?vue&type=script&lang=js&"
import style0 from "./LocationType.vue?vue&type=style&index=0&id=d5dc5d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dc5d38",
  null
  
)

export default component.exports